import React, { useEffect } from "react";

import { useAnalytics } from "@common/analytics/useAnalytics";

import { PromoRowItem } from "./InterjectedRow.model";
import * as Styled from "./InterjectedRows.styles";
import { InterjectedRowShell } from "./InterjectedRowShell";

export interface PromoRowProps {
  row: PromoRowItem;
  onDismiss: () => void;
}

/** Announces a changelog entry the user hasn't seen yet, e.g. "New: Session Replay - See how it works". */
export const PromoRow = ({ row, onDismiss }: PromoRowProps) => {
  const { sendEvent } = useAnalytics();

  useEffect(() => {
    sendEvent("interjected_row_shown", { row_type: row.type, row_id: row.id });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const hasAction = Boolean(row.action_label && row.action_url);

  const onActionClick = () => {
    sendEvent("interjected_row_cta_clicked", { row_type: row.type, row_id: row.id });
    if (row.action_url) window.open(row.action_url, "_blank")?.focus();
  };

  return (
    <InterjectedRowShell
      label={row.title}
      testId="promo_row"
      onDismiss={onDismiss}
      descriptionTooltip={"A new update from the Shake team — not a bug report from your users"}
      action={hasAction ? <Styled.ActionButton onClick={onActionClick}>{row.action_label}</Styled.ActionButton> : null}
    >
      <Styled.Content>
        <Styled.IconBox>{row.icon}</Styled.IconBox>
        <Styled.Title p1>{row.title}</Styled.Title>
        <Styled.Description p2>{row.description}</Styled.Description>
      </Styled.Content>
    </InterjectedRowShell>
  );
};
